export default {
    kw_search: function(new_data){
        // console.log('kw_search');
        this.chart_filter = this.chart_filter_m(new_data);
        this.dsets = this.chart_filter['datasets'];
    },
}


// WEBPACK FOOTER //
// ./src/mixins/kw_search.js